<template>
  <div class="coach-agreement px-to-viewport-ignore">
    <p class="title">betterwe教练用户协议</p>
    <p class="t1">导言</p>
    <p class="b">尊敬的用户：</p>
    <p class="d"
      >非常感谢您注册使用betterwe教练产品，为让您更好地使用betterwe教练提供的产品和服务，请您务必审慎阅读、充分理解《betterwe教练用户协议》（以下称「用户协议」或「本协议」）各条款内容，特别是免除或者限制责任的条款，并选择接受或不接受。本协议中限制、免责条款可能以加粗形式提醒您注意。</p
    >
    <p class="d b"
      >除非您已阅读并接受本协议所有条款，否则您无权下载、安装或使用betterwe教练提供相关产品和服务。您的下载、安装、使用、登陆等行为即视为您已阅读并同意本协议的约束。</p
    >
    <p class="t1">1. 协议的范围</p>
    <p class="d"
      >1.1 betterwe教练App、微信小程序及H5网页程序（以下统称「betterwe教练产品」）是由长沙健盟网络科技有限公司及其关联公司（以下称「betterwe教练」或「我们」）提供的互联网产品和服务。</p
    >
    <p class="d"
      >1.2
      本用户协议是用户（您）与betterwe教练之间关于使用betterwe教练提供的产品和服务所订立的协议，本协议条款的效力及于betterwe教练所提供的一切产品和服务，用户在享受betterwe教练任何单项服务时，应当受本协议的约束。</p
    >
    <p class="d"
      >1.3
      本协议项下的产品和服务是指由betterwe教练发布的包括但不限于网络媒体、互联网增值、互动娱乐、电子商务、智能硬件和广告等的互联网产品和服务（形式包括但不限于在线视频、评论、跟帖、弹幕、图片、软件、技术代码等）。</p
    >
    <p class="d"
      >1.4
      本协议内容同时包括《隐私政策》及所有betterwe教练已经发布或未来可能发布的各类规则、公告或通知，且您在使用betterwe教练某一特定产品或服务时，可能会另有单独的协议、相关服务规则等，前述规则、公告、通知和协议一经发布即为本协议不可分割的组成部分，您同样应当遵守。如您不同意本协议的约定，您应立即停止注册/激活并停止使用betterwe教练的相关产品和服务。</p
    >
    <p class="d"
      >1.5
      betterwe教练有权根据需要不时地修订本协议及/或各类规则（包括但不限于制定新的条款和修改既有条款），并以在线公告的方式进行变更公告，无须另行单独通知您。修订后的协议和规则一经公布，立即或在公告明确的特定时间自动生效。若您在前述公告修订后继续使用betterwe教练的产品或服务，即视为您已阅读、理解并接受经过修订的协议和规则。若您不同意修订，应当立即停止使用betterwe教练提供的产品和服务。</p
    >
    <p class="d"
      >1.6
      除本协议明确规定外，对于利用betterwe教练开发/发布的产品和服务，betterwe教练有权在本协议的基础上通过单独的产品和服务协议（以下称「单项产品协议」）加以规范，用户须在使用有关产品或服务时另行了解与确认。单项产品协议与本协议有冲突的地方，以单项产品协议为准。如用户使用该产品或服务，即视为对相关单项产品协议的接受。</p
    >
    <p class="t1">2. betterwe教练产品及服务简介</p>
    <p class="d"
      >2.1
      betterwe教练为用户提供多样的互联网产品和服务，用户经betterwe教练认证后，可以通过betterwe教练对学员授课情况、排课情况进行管理。</p
    >
    <p class="d"
      >betterwe教练仅限于betterwe认证教练使用，用户非betterwe认证教练时，将无法使用betterwe教练下的任一服务。</p
    >
    <p class="d"
      >2.2
      betterwe教练尽力提供畅通无阻的在线服务，但平台的网络接入服务可能受多种因素的影响出现链接受阻、受限或被终止，由此给您带来的损失、不便，我们将不负任何责任。</p
    >
    <p class="d"
      >2.3
      betterwe教练仅提供在线产品和服务，除此之外与网络服务有关的设备（如手机、个人电脑、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。</p
    >
    <p class="t2">2.4 betterwe教练的替换、修改和升级：</p>
    <p class="d"
      >2.4.1
      为增进用户体验、完善服务内容，betterwe教练有权根据您对软件、程序的使用状态和行为开发新的服务；</p
    >
    <p class="d"
      >2.4.2
      为改进、增强和进一步开发服务，betterwe教练有权不时提供软件、程序更新（包括软件、程序升级替换、修改、功能强化、版本升级等形式）；</p
    >
    <p class="d"
      >2.4.3
      用户理解并同意：betterwe教练有权不向您特别通知而对betterwe教练进行更新，或对betterwe教练的部分功能进行改变或限制。</p
    >
    <p class="d"
      >2.4.4
      betterwe教练新版本发布后，旧版本可能无法使用。betterwe教练不保证旧版betterwe教练及相应的服务继续可用。为充分、及时使用betterwe教练的服务，请您随时核对并下载最新版本。</p
    >
    <p class="t2">2.5 第三方应用及服务</p>
    <p class="d"
      >betterwe教练产品中提供了支持第三方应用供用户使用的功能模块，包括但不限于工具类服务、视频或图片类服务等，以及今后可能出现的各种服务。用户在使用该类应用程序时，应遵守本协议及该应用程序相应的协议、条款或规则的规定。用户与开发者之间的权利义务，参照相关协议、条款或规则执行。用户在使用第三方提供的软件和服务时，须了解并同意：</p
    >
    <p class="d"
      >2.5.1
      用户使用第三方开发者提供的应用与服务时，第三方开发者将根据用户授权获得用户的个人资料和内容信息。这些资料和信息由用户自行决定授权给第三方。用户须明确：您向第三方授权获得您个人资料和内容信息的行为，可能发生的信息泄露的风险；您在使用第三方服务的同时，除遵守本协议及betterwe教练的其他相关规则外，您还应遵守第三方的协议、相关规则。如因第三方软件及相关服务产生的争议、损失或损害，由您自行与第三方解决，betterwe教练对此不承担责任。</p
    >
    <p class="d"
      >2.5.2
      betterwe教练引入第三方服务的目的在于丰富betterwe教练产品，从而给用户创造更好的服务体验。但因第三方服务出现的瑕疵或错误而产生的责任，由第三方自行承担，与betterwe教练无关。当然，betterwe教练会对第三方提供的服务进行审查或审核，但基于服务的专业性，难免存在遗漏。第三方服务商并不因betterwe教练的审查或审核疏漏而免于责任承担。</p
    >
    <p class="d"
      >2.5.3
      betterwe教练对第三方开发者提供的应用享有审核管理权，有权在不通知用户的情况下，对第三方应用进行下架处理，由此给用户带来的影响、损失，betterwe教练将不承担责任，由用户自行承担或与第三方协商，但betterwe教练将尽力保障用户权益不受侵犯。</p
    >
    <p class="d">2.5.4 用户使用第三方应用时，须同意：</p>
    <p class="d">授权使用自己的betterwe教练账号登陆第三方应用；</p>
    <p class="d">（2）同意第三方应用获取自己的个人资料，以获得相应产品和服务。</p>
    <p class="d"
      >2.5.5
      用户因使用第三方应用而与该第三方开发者产生的任何纠纷，由用户与开发者自行协商解决，相关责任和赔偿由开发者单独承担，betterwe教练不承担任何责任。</p
    >
    <p class="t1">3. 用户的账号、密码和安全性</p>
    <p class="t2">3.1 注册资格</p>
    <p class="d"
      >3.1.1
      您确认，在您完成注册程序或以其他betterwe教练允许的方式实际使用betterwe教练提供的产品和服务时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，且betterwe教练有权注销或永久冻结您的账户，并保留向您或您的监护人索取赔偿的权利。</p
    >
    <p class="d"
      >3.1.2
      betterwe教练仅限于betterwe认证教练使用，若您非betterwe认证教练，即使您成功注册账户，亦无法使用本产品下的任一服务。</p
    >
    <p class="t2">3.2 注册与账户</p>
    <p class="d"
      >3.2.1
      为完整使用betterwe教练提供的产品和服务，您须注册betterwe教练提供的账户。您注册betterwe教练账户时须对所提供信息的真实性、合法性、有效性及完整性负责，并及时维护和更新您的个人信息，以保证信息的真实、合法和有效。</p
    >
    <p class="d"
      >3.2.2
      您在betterwe教练中的注册账号所有权及有关权益均归公司所有，您完成注册手续后仅享有该账号的使用权。您的账号仅限于您本人使用，未经betterwe教练书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。如果betterwe教练发现或者有合理理由认为使用者并非账号初始注册人，betterwe教练有权暂时或终止向该注册账号提供服务，并有权注销该账号，而无需向注册该账号的用户承担法律责任。</p
    >
    <p class="d"
      >3.3
      betterwe教练在此特别提醒您务必保护好您的账号及密码，切勿将账号及密码透露给他人。您须自行负责对您的账户和密码进行保密，且须对在您的账户和密码下发生的所有活动（包括但不限于信息披露、信息发布、网上点击同意或提交各类规则协议、网上续签协议或购买服务等）承担责任。betterwe教练不能也不会对因您未能遵守本条款规定而发生的任何损失负责。若您发现任何人未经授权使用您的账号及密码，您须立即通知betterwe教练。你可以发送邮件至
      wegymer01@163.com
      提出您的请求。您须理解并同意betterwe教练根据您的请求采取行动需要合理时间，对在采取行动前已产生的任何不利后果，betterwe教练不承担任何责任。因其他人恶意攻击或您自身原因或其他不可抗因素而导致账号盗窃、丢失、均由您本人承担责任，betterwe教练不承担任何责任。</p
    >
    <p class="t2"
      >3.4
      您可以对账户设置昵称，您设置的昵称不得侵犯或涉嫌侵犯他人的合法权益。用户承诺设置昵称时遵守以下规定：</p
    >
    <p class="d">3.4.1不以党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名注册；</p>
    <p class="d">3.4.2不以国家机构或其他机构的名称注册；</p>
    <p class="d">3.4.3不注册不文明、不健康名字，或包含歧视、侮辱、猥亵类词语的账号；</p>
    <p class="d">3.4.4不注册易产生歧义、引起他人误解或其它不符合法律规定的账号。</p>
    <p class="d"
      >如您设置的昵称涉嫌侵犯他人合法权益，betterwe教练有权终止向您提供部分或全部软件服务。betterwe教练对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。</p
    >
    <p class="t2">3.5 用户同意授权betterwe教练基于下列原因使用用户的信息资源</p>
    <p class="d">3.5.1执行软件验证、升级服务；</p>
    <p class="d">3.5.2提高用户的使用安全性或提供客户支持；</p>
    <p class="d"
      >3.5.3应用户特殊要求而提供特定服务时，需要将信息提供给betterwe教练或与此相关联的第三方或其他用户；</p
    >
    <p class="d"
      >3.5.4将各种非个人隐私数据用于商业目的，包括但不限于向第三方提供增值服务、广告、定位广告、营销、联合注册、促销或其他活动等；</p
    >
    <p class="d">3.5.5应司法机关或政府机关要求；</p>
    <p class="d">3.5.6为提高用户使用体验；</p>
    <p class="d">3.5.7其他有利于用户和betterwe教练利益且不违反任何强制性法律法规的情况。</p>
    <p class="t1">4. betterwe教练使用规范</p>
    <p class="d"
      >4.1
      用户须对自己的上网行为负责，包括对自己发表、上传或传送的内容（包括文字、评论、图片、视频内容、软件产品等）负全部责任。用户须承诺在betterwe教练平台上所发布的任何内容均符合中华人民共和国法律、法规、规章以及betterwe教练管理规范的规定。betterwe教练有权对用户发布的任何不符合管理规定的内容予以删除，且不承担任何责任。</p
    >
    <p class="d"
      >4.2
      用户承诺在使用betterwe教练产品和服务（包括但不限于：文字、评论、图片、视频内容、软件产品等）过程中，应自觉遵守法律法规、社会主义制度、国家利益、公民合法权益、社会公共秩序、道德风尚和信息真实性等“七条底线”要求，不发布、转载、传送含有下列内容之一的内容，否则betterwe教练有权自行处理并不通知用户。</p
    >
    <p class="t2">4.3 用户不得发表下列信息：</p>
    <p class="d">4.3.1反对宪法确定的基本原则的；</p>
    <p class="d">4.3.2危害国家安全，泄漏国家机密；</p>
    <p class="d">4.3.3颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家统一的；</p>
    <p class="d">4.3.4损害国家荣誉和利益的；</p>
    <p class="d">4.3.5宣扬恐怖主义、极端主义的；</p>
    <p class="d">4.3.6宣扬民族仇恨、民族歧视，破坏民族团结的；</p>
    <p class="d">4.3.7煽动地域歧视、地域仇恨的；</p>
    <p class="d">4.3.8破坏国家宗教政策，宣扬邪教和迷信的；</p>
    <p class="d">4.3.9编造、散布谣言、虚假信息，扰乱社会秩序、破坏社会稳定的；</p>
    <p class="d">4.3.10散布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
    <p class="d">4.3.11危害网络安全、利用网络从事危害国家安全、荣誉和利益的；</p>
    <p class="d">4.3.12侮辱或者诽谤他人，侵害他人合法权益的；</p>
    <p class="d">4.3.13对他人进行暴力恐吓、威胁，实施人肉搜索的；</p>
    <p class="d">4.3.14涉及他人隐私、个人信息或资料的；</p>
    <p class="d">4.3.15散布污言秽语，损害社会公序良俗的；</p>
    <p class="d">4.3.16侵犯他人隐私权、名誉权、肖像权、知识产权等合法权益内容的；</p>
    <p class="d">4.3.17散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息；</p>
    <p class="d"
      >4.3.18恶意刷屏、发布大量与平台服务无关的垃圾信息或无意义字符，干扰其他用户使用体验的；</p
    >
    <p class="d">4.3.19侵害未成年人合法权益或者损害未成年人身心健康的；</p>
    <p class="d">4.3.20未获他人允许，偷拍、偷录他人，侵害他人合法权利的；</p>
    <p class="d"
      >4.3.21包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的，包括但不限于以下情形：</p
    >
    <p class="d">（1）任何暴力和/或自残行为内容；</p>
    <p class="d"
      >（2）任何威胁生命健康、利用刀具等危险器械表演的危及自身或他人人身及/或财产权利的内容；</p
    >
    <p class="d">（3）怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容。</p>
    <p class="d"
      >4.3.22其他违反法律法规、政策及公序良俗、干扰betterwe教练正常运营或侵犯其他用户或第三方合法权益内容的其他信息。</p
    >
    <p class="t2">4.4 用户使用betterwe教练产品与服务时，承诺并遵守以下规定：</p>
    <p class="d"
      >4.4.1实施的所有行为均遵守国家法律、法规等规范性文件及betterwe教练各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议的相关规则。</p
    >
    <p class="d"
      >4.4.2不发布国家禁止的或涉嫌侵犯他人知识产权或其他合法权益的产品或服务信息，不发布违背社会公共利益或公共道德或betterwe教练认为不适合在betterwe教练上发布的产品或服务信息，不发布其他涉嫌违法或违反本协议及各类规则的信息。</p
    >
    <p class="d"
      >4.4.3除用户与betterwe教练另有约定，用户不得对betterwe教练中的任何数据/资料作商业性利用，包括但不限于在未经betterwe教练事先书面同意的情况下，以复制、传播等任何方式使用betterwe教练中展示的所有资料或课程。</p
    >
    <p class="d"
      >4.4.4不得使用任何装置、软件或程序干预或试图干预betterwe教练的正常运作或正在betterwe教练平台上进行的任何交易和活动。</p
    >
    <p class="d"
      >4.4.5除法律另有强制性规定外，未经betterwe教练明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用betterwe教练产品内的信息内容，否则，betterwe教练有权追究其法律责任。</p
    >
    <p class="t2"
      >4.5
      经betterwe教练书面许可后，用户对betterwe教练软件及相关服务的信息和内容的分享、转发等行为，还应符合以下规范：</p
    >
    <p class="d"
      >4.5.1不得对betterwe教练软件及相关服务的源网页进行任何形式的任何改动，包括但不限于betterwe教练软件及相关服务的首页链接入口，也不得对betterwe教练软件及相关服务的源页面的展示进行任何形式的遮挡、插入、弹窗等妨碍；</p
    >
    <p class="d"
      >4.5.2应当采取安全、有效、严密的措施，防止betterwe教练软件及相关服务的信息内容被第三方通过包括但不限于“蜘蛛”（spider）程序等任何形式进行非法获取；</p
    >
    <p class="d"
      >4.5.3不得把相关数据内容用于betterwe教练书面许可范围之外的目的，进行任何形式的销售和商业使用，或向第三方泄露、提供或允许第三方为任何方式的使用。</p
    >
    <p class="t2">4.6 用户充分理解并同意：</p>
    <p class="d"
      >4.6.1用户如果违反前述承诺及规范，产生任何法律后果的，用户应以自己的名义独立承担所有的法律责任，并确保betterwe教练免于因此产生的任何损失或增加费用。</p
    >
    <p class="d"
      >4.6.2用户如果违反法律或本协议规定造成betterwe教练被第三人索赔的，用户应全额补偿betterwe教练的一切费用（包括但不限于各种赔偿费、诉讼代理费及为此支出的其他合理费用）。</p
    >
    <p class="d"
      >4.6.3当第三方认为用户发表、上传的内容/产品（包括但不限于视频、图片、文字、应用程序、软件等）侵犯其权利，或国家行政、司法机关的生效法律文书确认您存在违法、侵权行为，或betterwe教练基于自身判断，认为您的行为违反国家法律法规的规定或涉嫌违反本协议条款的，betterwe教练有权自行决定删除相关信息，并在betterwe教练或网站上公示您的涉嫌违法/违约行为及对您采取的措施。</p
    >
    <p class="d"
      >4.6.4对于用户在betterwe教练上发布涉嫌违法、违约或侵犯他人合法权利的内容，betterwe教练有权不经通知予以删除，且不承担任何责任。</p
    >
    <p class="t2">4.7 学员信息保护</p>
    <p class="d b"
      >4.7.1用户仅可在履行其与betterwe教练约定的教学、课程管理及学员服务职责所必需的范围内，通过本APP查阅、使用学员信息。未经betterwe教练书面授权，用户不得将学员信息用于与工作无关的目的。</p
    >
    <p class="d b"
      >4.7.2用户应妥善保管其APP账号、密码及验证信息，不得向任何第三方出借、转让、共享或泄露。因用户保管不善、违规操作或授权他人使用账号造成学员信息泄露、丢失、篡改、被不当使用的，由用户承担全部责任。</p
    >
    <p class="d b">4.7.3未经betterwe教练及相关学员明确同意，用户不得实施下列行为：</p>
    <p class="d b">（1）复制、下载、截屏、拍摄、导出、打印、传播或以其他方式留存学员信息；</p>
    <p class="d b"
      >（2）向其他用户、员工、学员、外部机构或任何第三方披露、出售、交换、出租、转让或提供学员信息；</p
    >
    <p class="d b"
      >（3）利用学员联系方式、健康信息、训练记录、消费记录或其他信息进行私下营销、招揽、交易、骚扰或其他非授权活动；</p
    >
    <p class="d b">（4）擅自删除、修改、伪造、隐藏或干扰学员信息及相关记录；</p>
    <p class="d b"
      >（5）绕过、破坏或规避betterwe教练的信息安全措施、权限管理机制或操作限制。</p
    >
    <p class="d"
      >4.7.4若服务对象涉及未成年人，用户应确保已取得未成年人监护人的同意后方可收集、使用其个人信息；不得收集与服务无关的未成年人个人信息。betterwe教练有权对涉及未成年人的信息采取更严格的保护措施。</p
    >
    <p class="d"
      >4.7.5用户发现或有理由怀疑发生账号被盗用、学员信息泄露、误发、丢失、篡改或其他信息安全事件的，应立即采取合理措施防止损失扩大，并及时向betterwe教练报告，不得隐瞒、拖延或擅自处理。</p
    >
    <p class="d"
      >4.7.6用户违反本条约定的，betterwe教练有权根据违约情节采取限制或暂停权限、冻结账号、停止排课、暂停合作、解除与用户的劳动关系或合作关系等措施；如用户行为造成betterwe教练、学员或第三方损失的，用户应赔偿因此产生的全部损失，包括但不限于直接损失、维权费用、调查费用、律师费及因处理信息安全事件产生的合理费用。</p
    >
    <p class="d"
      >4.7.7用户违反本条约定涉嫌违法犯罪的，betterwe教练有权依法向有关主管部门报案或举报，并配合相关调查。用户对学员信息的保密和保护义务，不因其离职、合作终止、账号注销或本协议终止而终止。</p
    >
    <p class="t1">5. 知识产权声明</p>
    <p class="d"
      >5.1
      betterwe教练依法享有betterwe教练产品的一切合法权属（包括但不限于知识产权及所有权）。betterwe教练的全部著作权及其他一切知识产权，以及与betterwe教练相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图标、色彩组合、界面设计、版面框架、有关数据、印刷材料、或电子文档等均受中国知识产权相关法律法规和有关的国际条约的保护。</p
    >
    <p class="d"
      >5.2
      betterwe教练产品及通过betterwe教练产品提供的视频、图片、技术软件等产品和信息，除用户自己上传或明确标示由第三方提供的之外，全部权利归属于betterwe教练。</p
    >
    <p class="d"
      >5.3betterwe教练在涉及betterwe教练产品及相关各项服务中拥有专利权、专利申请权、商标权、著作权及其他知识产权。betterwe教练并未因为本协议或者因为向用户提供betterwe教练以及相关产品和服务而授予用户任何与betterwe教练相关的知识产权。本协议未明确授予用户的权利均由betterwe教练保留。</p
    >
    <p class="t1">6. 用户隐私制度</p>
    <p class="d"
      >6.1
      保护用户个人信息是betterwe教练的一项基本原则。betterwe教练将按照本协议及《隐私政策》的规定收集、使用、储存和分享您的个人信息。本协议对个人信息的保护规定与《隐私政策》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《隐私政策》的内容为准。</p
    >
    <p class="d"
      >6.2
      您在注册账号或使用betterwe教练产品和服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，可能无法使用betterwe教练的产品或服务，或在使用过程中受到限制。</p
    >
    <p class="d"
      >6.3
      您可以随时浏览、修改自己提交的信息，但出于安全性和身份识别（如账号申诉服务）的考虑，您可能无法修改注册时提供的部分初始注册信息及其他验证信息。betterwe教练保留您修改个人信息的审核权。</p
    >
    <p class="t2"
      >6.4 betterwe教练不会将您的个人信息转移或披露给任何非关联的第三方，除非：</p
    >
    <p class="d">6.4.1相关法律法规或法院、政府机关要求；</p>
    <p class="d">6.4.2为完成合并、分立、收购或资产转让而转移；</p>
    <p class="d">6.4.3事先获得您的授权；</p>
    <p class="d">6.4.4您使用共享功能；</p>
    <p class="d">6.4.5以学术研究或公共利益为目的；</p>
    <p class="d"
      >6.4.6在法律法规和政策允许的范围内，为提升用户体验和提供个性化的推广服务；</p
    >
    <p class="d">6.4.7我们认为必要且不违反法律强制性规定的其他情形。</p>
    <p class="d">6.5 除非经过您的同意，否则我们不会向任何人提供您的敏感个人信息。</p>
    <p class="t1">7. 免责声明</p>
    <p class="d"
      >7.1
      用户理解并同意，在使用betterwe教练服务的过程中，可能会遇到不可抗力等风险因素，使服务发生中断、延迟。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害（如洪水、台风、地震等）、社会事件（如战争、暴动、政府行为）等，出现上述情况时，betterwe教练会努力对产品和服务进行修复，但由此给您造成的损失，betterwe教练在法律允许的范围内免责。</p
    >
    <p class="t2"
      >7.2 在法律允许的范围内，betterwe教练对以下情形导致的服务终端或受阻不承担责任：</p
    >
    <p class="d">7.2.1受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
    <p class="d">7.2.2用户或betterwe教练的电脑软件、系统、硬件和通信线路出现故障；</p>
    <p class="d">7.2.3用户操作不当；</p>
    <p class="d">7.2.4用户使用非betterwe教练授权的方式使用本服务；</p>
    <p class="d">7.2.5其他betterwe教练无法控制或合理预见的情形。</p>
    <p class="t2"
      >7.3
      用户理解并同意，在使用betterwe教练产品和服务的过程中，可能会遇到网络信息或其他用户带来的风险和损害，betterwe教练不对任何信息或产品的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：</p
    >
    <p class="d">7.3.1来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；</p>
    <p class="d"
      >7.3.2因使用本协议项下产品或服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理以及经济上的损害。</p
    >
    <p class="d"
      >7.4
      betterwe教练依据本协议享有处理不法、违规内容、产品或服务的权利，但该权利不构成betterwe教练的义务和承诺，betterwe教练不保证及时发现并做出相应处理。</p
    >
    <p class="d"
      >7.5
      对于单项产品运营者通过betterwe教练向您提供的单项产品或服务，由单项产品运营者独立承担与该项产品或服务有关的全部责任和义务，其他betterwe教练对此不承担任何责任和义务。</p
    >
    <p class="t1">8. 产品/服务的变更、中止或结束</p>
    <p class="t2"
      >8.1
      用户应规范、合法地使用betterwe教练及服务，如用户发布违法、违背社会公德或违背本协议约定的信息，或有违反相关法律法规或本协议的行为，betterwe教练有权采取以下措施：</p
    >
    <p class="d">8.1.1直接删除违反法律法规或本协议的内容；</p>
    <p class="d"
      >8.1.2中止或限制您使用betterwe教练及其产品和服务的权利，包括但不限于限制您使用betterwe教练部分或全部功能及产品、服务等；</p
    >
    <p class="d">8.1.3终止您使用betterwe教练的权利；</p>
    <p class="d">8.1.4回收您的账号，同时有权禁止您申请或通过其他方式取得新的账号；</p>
    <p class="d">8.1.5依法追究您的法律责任，索取相应损害赔偿金。</p>
    <p class="d"
      >8.2
      betterwe教练有权根据业务发展需要中止、变更、终止betterwe教练产品或其部分功能，并有权决定是否（继续）提供betterwe教练中的某种产品和服务；对于前述情形，betterwe教练并不负有向用户通知的义务。</p
    >
    <p class="d"
      >8.3
      除法律另有规定外，用户有责任自行备份存储在betterwe教练的数据，如用户的服务被终止，betterwe教练有权从服务器上永久地删除您在betterwe教练的全部相关数据，并不负有向您返还或以任何形式提供前述数据的义务。</p
    >
    <p class="d"
      >8.4
      您可以在betterwe教练软件中开启和使用单项或特定服务。某些单项服务可能需要您同时接受就该服务特别制订的协议或者其他约束您与该项服务提供者之间的规则。betterwe教练将以醒目的方式提供这些协议、规则供您查阅。一旦您开始使用上述服务，则视为您同时接受有关单项服务的相关协议、规则的约束。</p
    >
    <p class="t1">9. 适用法律及争议解决方式</p>
    <p class="d">9.1 本协议签订地为中华人民共和国长沙市开福区。</p>
    <p class="d"
      >9.2 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p
    >
    <p class="d"
      >9.3
      若您与betterwe教练运营者发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交至本协议签订地所在地法院诉讼解决。</p
    >
    <p class="t1">10. 其他规定</p>
    <p class="d"
      >10.1
      如本协议中的任何条款因任何原因部分无效或不具有执行力，不影响本协议中其余条款对双方的约束力。</p
    >
    <p class="d">10.2 本协议条款的标题仅为方便阅读而设，不作为解释本协议条款的依据。</p>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
.coach-agreement {
  padding: 12px;
  font-size: 14px;
  word-break: break-all;

  .title {
    margin-bottom: 20px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
  }

  p {
    padding: 0;
    margin: 0;
    margin-bottom: 4px;
  }

  .b {
    font-weight: 600;
  }

  .t1 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .t2 {
    font-weight: 600;
    margin-bottom: 4px;
  }

  .d {
    margin-bottom: 10px;
  }
}
</style>
